import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { __, setTableParams } from '../../../../core/utils';
import {
  setCursorTooltip,
  updateTool,
} from '../../../../redux/actions/canvas_editor';
import Button from '../Toolbar/Button';
import { getStatusColor } from './taskStatusColors';
import TaskCursorIcon from '../../images/Icon20_Task.png';
import TaskIcon from '../../images/Icon20_Task.svg';
import { toString } from 'lodash';
import { listPlanVersionTasks } from '../../../../redux/actions/table/working_set_plans';
import { listPlanRevisionTasks } from '../../../../redux/actions/table/current_set_plans';

const Task = ({
  canvas_editor: { viewer, fabricOverlay },
  isActive,
  source,
  table,
  user_id,
  match,
}) => {
  const table_name =
    match.path == '/plans/revisions/:plan_revision'
      ? 'current_set_plans'
      : 'working_set_plans';

  table = table[table_name];

  useEffect(() => {
    if (!isActive || !fabricOverlay) return;

    const canvas = fabricOverlay.fabricCanvas();

    //canvas.defaultCursor = 'crosshair';
    canvas.defaultCursor = `url(${TaskCursorIcon}) 10 22, auto`;
    //canvas.hoverCursor = 'crosshair';

    setCursorTooltip(__('canvas.tooltip.task'));

    canvas.getObjects().forEach((obj) => {
      obj.selectable = false;
      obj.evented = false;
    });

    function onMouseDown(options) {
      if (options.target || !isActive) return;

      const rawPointer = canvas.getPointer(options.e);

      const x = rawPointer.x;
      const y = rawPointer.y;

      viewer.setMouseNavEnabled(true);

      if (x < 0 || x > source.width || y < 0 || y > source.height) {
        return;
      }

      const imageWidth = viewer.source.dimensions.x;
      const imageHeight = viewer.source.dimensions.y;

      setTableParams('all_tasks', {
        x,
        y,
        attach_task_wizard: true,
        stage_id: source.stage_id,
        left: x / imageWidth,
        top: y / imageHeight,
      });
    }

    const onPointerDown = (e) => {
      viewer.setMouseNavEnabled(false);
    };

    canvas.upperCanvasEl.addEventListener('pointerdown', onPointerDown);

    canvas.on('mouse:down', onMouseDown);

    return () => {
      canvas.off('mouse:down', onMouseDown);
      canvas.upperCanvasEl.removeEventListener('pointerdown', onPointerDown);
    };
  }, [fabricOverlay, isActive]);

  const createTask = (x, y, taskId, uid, color) => {
    const canvas = fabricOverlay.fabricCanvas();

    const obj = new fabric.Path(
      'M8.67,8.53a28.89,28.89,0,0,0-.41,40.85l.41.41L28.87,69.7a1,1,0,0,0,1.4,0l20.2-19.91a28.9,28.9,0,0,0,.39-40.87l-.39-.39A29.88,29.88,0,0,0,8.67,8.53Z'
    );

    obj.setCoords();

    let lockmov = true;

    if (uid == user_id) lockmov = false;

    obj.set({
      left: x,
      top: y,
      objectType: 'task',
      originalLeft: x,
      originalTop: y,
      taskID: taskId,
      userID: uid,
      //moving: false,
      lockScalingX: true,
      lockScalingY: true,
      // lockMovementX: lockmov,
      // lockMovementY: lockmov,
      hasControls: false,
      hasBorders: false,
      fill: color,
      stroke: color,
    });

    if (table_name === 'current_set_plans') {
      listPlanRevisionTasks(match.params.plan_revision);
    } else listPlanVersionTasks(match.params.plan_version);

    canvas.add(obj);

    //canvas.requestRenderAll();

    viewer.setMouseNavEnabled(true);
  };

  useEffect(() => {
    if (table.task_id) {
      const color = getStatusColor(table.status);

      createTask(table.x, table.y, table.task_id, user_id, color);

      setTableParams(table_name, {
        task_id: undefined,
        x: undefined,
        y: undefined,
      });
    }
  }, [table?.task_id]);

  const toggleTool = () => {
    updateTool({ tool: 'task' });
  };

  return (
    <Button
      id='task'
      label={__('canvas.toolbar.task')}
      icon={TaskIcon}
      active={isActive}
      onClick={toggleTool}
      extraClass={['roundedUp']}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    canvas_editor: state.canvas_editor,
    table: state.table,
    user_id: state.auth.id,
  };
};

export default withRouter(connect(mapStateToProps, null)(Task));
